import { render, staticRenderFns } from "./InvestorList.vue?vue&type=template&id=533b7217&scoped=true&lang=pug&"
import script from "./InvestorList.vue?vue&type=script&lang=ts&"
export * from "./InvestorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b7217",
  null
  
)

export default component.exports